import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwapVertCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swap_vert_circle"}/>
}
